import {
  FINANCIAL_ADJUSTMENTS,
  READ_ACTION
} from '@/constants/resources'
  

/**
 * A lista aceita filtros pela query string, com os MESMOS nomes de
 * `FinancialAdjustmentController::searchRules()` — a URL é espelho 1:1 do corpo do
 * POST `/api/financial_adjustments/search`:
 *
 *   /ajustes-financeiros?paying_company_id=2&consultant=123
 *
 * - `consultant`, `adjustment_reason`, `status`: aceitam repetição (`?status=a&status=b`).
 * - `credit_type`: `credit` ou `debt` (⚠️ `debt`, não `debit`).
 * - `paying_company_id`: id da empresa OU a sentinela `none` (sem empresa pagadora).
 * - `launch_date_start` / `launch_date_end`: data de LANÇAMENTO.
 *
 * ⚠️ NÃO existe filtro por competência/fatura. Quem chega de um "Total Futuro Hub" só consegue
 * recortar por PN + CNPJ; a competência ainda é conferida a olho na coluna "Mês da fatura".
 *
 * Quem lê e aplica isso é `FinancialAdjustmentsListFilters` (hook `created`), antes do `mounted`
 * da view disparar a busca.
 *
 * ⚠️ Rota atrás do menu financeiro (`fixedFinancialMenuRole`). Antes de criar link para cá,
 * cheque a permissão do usuário: o interceptor de `helpers/api.js` DESLOGA em 401/403/419, então
 * um link visível para quem não pode entrar derruba a sessão dele.
 */
export default [
  {
    path: '/ajustes-financeiros',
    name: 'financial-adjustments-list',
    component: () => import('@/modules/financial_adjustment/views/FinancialAdjustmentsList.vue'),
    meta: {
      resource: FINANCIAL_ADJUSTMENTS,
      action: READ_ACTION,
      fixedFinancialMenuRole: true,
      pageTitle: 'Ajustes'
    },
  }
]
  
